<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const { t } = useI18n();
</script>

<template>
  <MpText no-margin>
    {{ t('JOB_CARD.SAVE_JOB_SUCCESS_TOAST.SUBTITLE_1') }}
    <LinksLocale :to="{ name: 'my-favorite-jobs' }">
      <MpText
        link
        style="color: inherit"
      >
        {{ t('JOB_CARD.SAVE_JOB_SUCCESS_TOAST.SUBTITLE_2') }}
      </MpText>
    </LinksLocale>
  </MpText>
</template>
